module.exports = __webpack_public_path__ + "static/media/Colette Straight Queen Headboard - 155 cm_Grey.fc864158.png";